import { MAX_FLOWS } from "src/analytics/workspace/workspaceInsightsAgentContext";
import { analyticsQueryApi } from "src/api/endpoints";
import type { ResultsValue } from "src/clients/analytics-query";

const VOLUME_WINDOW_DAYS = 30;

export type FlowVolume = { flowId: string; decisions30d: number };

export type WorkspaceFlowsSnapshot = {
  flowVolumes: FlowVolume[];
  flowCount: number;
};

const resultRows = (
  slice: ResultsValue | undefined,
): ReadonlyArray<ReadonlyArray<unknown>> =>
  slice && !("error" in slice) ? slice.rows : [];

export const fetchWorkspaceFlowsSnapshot = async (
  baseUrl: string,
): Promise<WorkspaceFlowsSnapshot> => {
  const window = `start_datetime >= CURRENT_TIMESTAMP - INTERVAL '${VOLUME_WINDOW_DAYS} days'`;
  const response = await analyticsQueryApi(
    baseUrl,
  ).querySqlAnalyticsApiV1QueryPost({
    queryRequest: {
      queries: {
        flow_volumes: `SELECT flow_id, COUNT(*) AS n FROM flow_data WHERE ${window} GROUP BY 1 ORDER BY 2 DESC LIMIT ${MAX_FLOWS}`,
        flow_count: `SELECT COUNT(DISTINCT flow_id) AS n FROM flow_data WHERE ${window}`,
      },
    },
  });

  const results = response.data.results ?? {};
  const failed = ["flow_volumes", "flow_count"].filter(
    (name) => results[name] === undefined || "error" in (results[name] ?? {}),
  );
  if (failed.length > 0) {
    throw new Error(`Workspace preflight query failed: ${failed.join(", ")}`);
  }

  return {
    flowVolumes: resultRows(results.flow_volumes).map((r) => ({
      flowId: String(r[0]),
      decisions30d: Number(r[1]),
    })),
    flowCount: Number(resultRows(results.flow_count)[0]?.[0] ?? 0),
  };
};
